export enum RouterPath {
    HOME = '',
    FORBIDDEN = 'forbidden',
    // 1. Header
    // 1.1. Product menu
    // 1.1.1. Services submenu
    SERVICES = 'services',
    GEOGRAPHIC = 'geographic',
    CADASTRAL_TRIAL = 'cadastral-trial',
    CADASTRAL = 'cadastral',
    COMPANY_TRIAL = 'company-trial',
    COMPANY = 'company',
    EKYC = 'ekyc',
    EMBEDDING = 'embedding',
    DATA_INSIGHTS = 'data-insights',
    // 1.1.2. Data products submenu
    GET_DATA = 'get-data',
    DATA_DOMAINS = 'data-domains',
    DATASET_GROUPS = 'dataset-groups',
    DATASETS = 'datasets',
    DATASET_PENDING_LIST = 'dataset-pending-list',
    DATASET_UPCOMING_LIST = 'dataset-upcoming-list',
    IMPORT = 'import',
    // 1.1.3. HPC (checkout, success, fail: the Pricing segments)
    HPC = 'hpc',
    REGISTER_ORG = 'register-org',
    PAYMENT = 'payment',
    // PayPal return URLs: `paypal` once approved, `paypal/cancel` when the buyer leaves PayPal
    PAYPAL = 'paypal',
    CANCEL = 'cancel',
    // 1.2. Demo menu
    DEMO = 'demo',
    // The same subpaths as GET_DATA's
    // 1.3. News menu
    // News
    // Blog
    // 1.4. About us menu
    ABOUT = 'about',
    // 1.5. Pricing menu
    PRICING = 'pricing',
    CHECKOUT = 'checkout',
    FAIL = 'fail',
    SUCCESS = 'success',
    VNPAY = 'vnpay',
    // 1.6. Profile menu
    PROFILE = 'profile',
    ORDER_HISTORY = 'order-history',
    ORDER_DETAIL = 'order-detail',
    ORDER_REVIEW = 'order-review',
    DETAIL = 'detail',
    CHANGE_PASSWORD = 'change-password',
    ACCEPTED_POLICY_LIST = 'accepted-policy-list',
    API_KEYS = 'api-keys',
    PACKETS = 'packets',
    PARTNERS = 'partners',
    APIS = 'apis',
    DASHBOARD = 'dashboard',
    TEMPLATES = 'templates',
    POLICIES = 'policies',
    // 2. Footer
    // 2.1. About & General Information
    // 2.1.1. About DataCore
    // /about
    // 2.1.2. DataCore FAQs
    FAQS = 'faqs',
    // 2.1.3. DataCore Blog
    // Blog
    // 2.1.4. DataCore News
    // News
    // 2.1.5. Docs
    DOCS = 'docs',
    USER_GUIDE = 'user-guide',
    POLICY = 'policy',
    TERMS = 'terms',
    API_INTEGRATION_GUIDE = 'api-integration-guide',
    // 2.1.6. Demo
    // /demo/data-domains
    // 2.2. Requests & Forms
    // 2.2.1. Vendor form
    VENDOR_FORM = 'vendor-form',
    // 2.2.2. Custom data request
    CUSTOM_DATA_REQUEST = 'custom-data-request',
    // 2.2.3. DataCore Partner
    DATACORE_PARTNER = 'datacore-partner',
    // 2.2.4. DataCore Partnership
    DATACORE_PARTNERSHIP = 'datacore-partnership',
    CERTIFICATE = 'certificate',
    PARTNER = 'partner',
    // 2.2.5. DataCore COR3
    DATACORE_COR3 = 'datacore-cor3',
    // 2.2.6. DataCore Scholars & Fellows
    DATACORE_SCHOLARS_FELLOWS = 'datacore-scholars-fellows',
    SCHOLAR = 'scholar',
    FELLOW = 'fellow',
    APPLICATION_FORM = 'apply',
    // 2.3. Policies & Terms
    // 2.3.1. Privacy Policy
    // /docs/policy
    // 2.3.2. Terms of use
    // /docs/terms
    // 2.4. Contributions & Contact
    // 2.4.1. Feedback
    FEEDBACK = 'feedback',

    // Not displayed paths
    REGISTER = 'register',
    REGISTER_ACADEMIC = 'register-academic',
    SET_NEW_PASSWORD = 'new-password',
}
